import { FC } from 'react';
import styled from 'styled-components';
import { RouteComponentProps } from '@reach/router';
import { Sidebar } from './Sidebar';
import { Problem } from './Problem';
import { colors } from '../config/theme';

export const ProblemRoute: FC<RouteProps> = ({ file }) => (
  <Wrapper>
    <Sidebar />
    <Problem file={file} />
  </Wrapper>
);

const Wrapper = styled.div`
  background: ${colors.blue_grey_050};
  min-height: 100vh;
`;

interface RouteProps extends RouteComponentProps {
  file: string;
}
